module.exports = __webpack_public_path__ + "img/hero_image_branches_mobile.a15a64b.jpg";